var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var AiStarIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M47.4272 7.59375C44.9689 8.625 43.0105 10.5937 41.9793 13.0417C41.6772 13.7604 40.698 13.7604 40.396 13.0417C39.3647 10.5833 37.396 8.625 34.948 7.59375C34.2293 7.29167 34.2293 6.3125 34.948 6.01042C37.4064 4.97917 39.3647 3.01042 40.396 0.5625C40.698 -0.15625 41.6772 -0.15625 41.9793 0.5625C43.0105 3.02083 44.9793 4.97917 47.4272 6.01042C48.146 6.3125 48.146 7.29167 47.4272 7.59375ZM1.9375 26.8022C10.6042 30.4481 17.5521 37.3856 21.1979 46.0626C22.2604 48.5939 25.7292 48.5939 26.7917 46.0626C30.4375 37.396 37.375 30.4481 46.0521 26.8022C48.5833 25.7397 48.5833 22.271 46.0521 21.2085C37.3854 17.5627 30.4375 10.6252 26.7917 1.94807C25.7292 -0.583181 22.2604 -0.583181 21.1979 1.94807C17.5521 10.6147 10.6146 17.5627 1.9375 21.2085C-0.59375 22.271 -0.59375 25.7397 1.9375 26.8022ZM24 5.83349C27.8854 13.6564 34.3437 20.1043 42.1667 24.0002C34.3437 27.896 27.8958 34.3439 24 42.1668C20.1042 34.3439 13.6562 27.896 5.83333 24.0002C13.6562 20.1043 20.1042 13.6564 24 5.83349Z",
    fill: "black"
  }));
};
export var AiStarIconGlyph = function (props) {
  return React.createElement(AiStarIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};